import { render, staticRenderFns } from "./IcoPaperEnvelope.vue?vue&type=template&id=26dee46a"
import script from "./IcoPaperEnvelope.vue?vue&type=script&lang=js"
export * from "./IcoPaperEnvelope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports